window.angular
    .module('hippo')
    .directive('scrollTracking', function (analyticsService, $timeout, $rootScope, featureToggle, $location) {
        'ngInject';
        const { $ } = window;

        return {
            link: function () {
                let scrollHeight = 0;

                const percentageIncrement = 20;
                let lastScrolledPercentageIncrement = 0;

                const trackScrollPercentage = () => {
                    const $scrollableElement = getScrollableElement();
                    const scrollPercent =
                        scrollHeight === 0 ? 0 : ($scrollableElement.scrollTop() / scrollHeight) * 100;

                    for (let i = percentageIncrement; i <= 100; i += percentageIncrement) {
                        if (scrollPercent > i && i > lastScrolledPercentageIncrement) {
                            analyticsService.track('scroll depth', { percent: i });
                            lastScrolledPercentageIncrement = i;
                        }
                    }
                };

                const resetScrollTracking = () => {
                    lastScrolledPercentageIncrement = 0;
                };

                const getScrollableElement = () => {
                    const $page = $('.page');
                    const $window = $(window);
                    const isNewDesignLandingPage = featureToggle.showNewDesign() && $location.path() === '/';

                    return $page.length && !isNewDesignLandingPage ? $page : $window;
                };

                const calculateTotalScrollHeight = () => {
                    const $staticPage = $('.static-page');
                    const $page = $('.page');
                    const $scrollableElement = $staticPage.length ? $staticPage : $page;

                    scrollHeight = $scrollableElement[0].scrollHeight - $(window).height();
                };

                window.addEventListener('resize', calculateTotalScrollHeight);

                const attachScrollEvent = () => {
                    const $scrollableElement = getScrollableElement();
                    $scrollableElement.scroll(trackScrollPercentage);
                };

                $rootScope.$on('$locationChangeSuccess', () => {
                    $timeout(() => {
                        resetScrollTracking();
                        calculateTotalScrollHeight();
                        attachScrollEvent();
                    }, 2000);
                });
            }
        };
    });
